import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { FaxPrefixes } from '@frontend/tracking-prefixes';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';

type Props = {
  onClick: () => void;
};
export const UploadBox = ({ onClick }: Props) => {
  const { t } = useTranslation('fax');
  return (
    <li
      css={css`
        box-sizing: border-box;
        margin-bottom: ${theme.spacing(3)};
        padding-top: ${theme.spacing(4)};
      `}
      onClick={onClick}
      data-trackingid={`${FaxPrefixes.Documents}-upload`}
    >
      <div
        css={css`
          width: 208px;
          height: 270px;
          box-sizing: border-box;
          padding: ${theme.spacing(3)};
          border-radius: ${theme.borderRadius.medium};
          background: ${theme.colors.neutral5};
          border: 1px dashed ${theme.colors.neutral20};
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          cursor: pointer;
          &:hover {
            border: 1px dashed ${theme.colors.neutral70};
          }
        `}
      >
        <Icon
          name='up'
          css={css`
            margin-bottom: ${theme.spacing(1)};
          `}
          color='subdued'
        />
        <Text color='subdued'>{t('Drag and drop or click to upload documents')}</Text>
        <NakedButton
          css={css`
            margin-top: ${theme.spacing(1)};
            width: auto;
            color: ${theme.colors.neutral50};
            border: 1px solid ${theme.colors.neutral50};
            border-radius: ${theme.borderRadius.small};
            padding: ${theme.spacing(1)} ${theme.spacing(2)};
          `}
        >
          {t('Click Here')}
        </NakedButton>
      </div>
    </li>
  );
};
